export const ROLE_PERMISSION_MAP = {
  super_admin: [
    'dashboard',
    'contract:list',
    'contract:add',
    'contract:edit',
    'contract:delete',
    'contract:upload',
    'contract:file_delete',
    'contract:download',
    'contract:ai',
    'dept',
    'role',
    'user'
  ],
  dept_admin: [
    'dashboard',
    'contract:list',
    'contract:add',
    'contract:edit',
    'contract:delete',
    'contract:upload',
    'contract:file_delete',
    'contract:download',
    'contract:ai'
  ],
  dept_user: [
    'dashboard',
    'contract:list',
    'contract:download',
    'contract:ai'
  ]
}

export function getCurrentUser() {
  try {
    const userStr = localStorage.getItem('contract_user')
    return userStr ? JSON.parse(userStr) : {}
  } catch (e) {
    return {}
  }
}

export function getRoleCode() {
  const user = getCurrentUser()
  return user.role_code || ''
}

export function hasPermission(permissionKey) {
  const roleCode = getRoleCode()
  const permissions = ROLE_PERMISSION_MAP[roleCode] || []
  return permissions.includes(permissionKey)
}

export function hasAnyPermission(permissionKeys = []) {
  return permissionKeys.some(key => hasPermission(key))
}

export function isSuperAdmin() {
  return getRoleCode() === 'super_admin'
}

export function isDeptAdmin() {
  return getRoleCode() === 'dept_admin'
}

export function isDeptUser() {
  return getRoleCode() === 'dept_user'
}